import { API2_HOST } from '../../helpers/urlHelper';
import { baseSearch, basePost, baseGet, basePatch } from 'services/base-services/baseService'

const baseURL = `${API2_HOST}/sm-skill-criterias`;
const search = async (request) => {
    return await baseSearch(baseURL, request);
}

const get = async (skillLevelId, skillActivityId) => {
    return await baseGet(baseURL, `${skillActivityId}/${skillLevelId}`);
}

const post = async (request) => {
    return await basePost(baseURL, request);
}

const patch = async (request) => {
    return await basePatch(baseURL, request);
}

export {
    search,
    patch,
    post,
    get
};

